'use client';

import { useMediaQuery } from '@mantine/hooks';
import { modals } from '@mantine/modals';
import type { ReactNode } from 'react';

type AutocompleteModalProps = {
  modalId: string;
  title?: string;
  modalContent?: ReactNode;
  fullScreen?: boolean;
};

export default function useAutocompleteModal() {
  const isMobile = useMediaQuery('(max-width: 767px)');

  function openModal({
    modalId,
    title,
    modalContent,
    fullScreen,
  }: AutocompleteModalProps) {
    modals.open({
      modalId,
      title,
      centered: true,
      withCloseButton: false,
      padding: 0,
      fullScreen: fullScreen ?? isMobile,
      children: modalContent,
    });
  }

  return { openModal };
}
